var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DATE_PATTERN_LONG, EMAIL_PATTERN } from '@pinwheel/origami';
var DATE_PATTERN_REGEX_DASHED = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
export var isOption = function (obj) {
    return obj !== null && typeof obj === 'object' && 'value' in obj;
};
// Empty selection will have an empty label, so use label instead of value
// To check if something is selected
export var isValueTruthy = function (val) { return (isOption(val) ? val.label : val); };
var getSubmitValue = function (val) { return (isOption(val) ? val.value : val); };
export var getSubmitPayload = function (obj) {
    return Object.entries(obj).reduce(function (acc, _a) {
        var _b;
        var k = _a[0], v = _a[1];
        return (__assign(__assign({}, acc), (_b = {}, _b[k] = getSubmitValue(v), _b)));
    }, {});
};
// ------------------------ VALIDATION LOGIC ------------------------
var checkConfigValueDefined = function (configValue) {
    return configValue !== undefined && configValue !== null;
};
var VALIDATORS = {
    minLength: function (configValue, value) {
        return checkConfigValueDefined(configValue) &&
            value.length < configValue &&
            "Length must be at least ".concat(configValue);
    },
    maxLength: function (configValue, value) {
        return checkConfigValueDefined(configValue) &&
            value.length > configValue &&
            "Length must be at most ".concat(configValue);
    },
    pattern: function (configValue, value) {
        return checkConfigValueDefined(configValue) &&
            !new RegExp(configValue).test(value) &&
            'Invalid input';
    },
};
var checkFor = function (fieldConfigKeys, fieldConfig, value) {
    if (value === void 0) { value = ''; }
    for (var i = 0; i < fieldConfigKeys.length; i++) {
        var fieldConfigKey = fieldConfigKeys[i];
        var fieldConfigValue = fieldConfig[fieldConfigKey];
        var errorString = VALIDATORS[fieldConfigKey](fieldConfigValue, value);
        if (errorString)
            return errorString;
    }
    return null;
};
/**
 * @returns error message as string if exists, else false
 */
export var isFieldInvalid = function (fieldConfig, value) {
    if (fieldConfig.lockedField)
        return false;
    if (fieldConfig.fieldType === 'date3Inputs') {
        // Accomodate for validating new DateInput component
        var fieldConfigOverride = __assign(__assign({}, fieldConfig), { pattern: DATE_PATTERN_REGEX_DASHED.source });
        return checkFor(['pattern'], fieldConfigOverride, value);
    }
    if (fieldConfig.fieldType === 'date') {
        // Accomodate for validating new DateInput component
        var fieldConfigOverride = __assign(__assign({}, fieldConfig), { pattern: DATE_PATTERN_LONG.source });
        return checkFor(['pattern'], fieldConfigOverride, value);
    }
    if (fieldConfig.fieldType === 'text') {
        if (fieldConfig.fieldSubtype === 'email') {
            // Accomodate for validating new EmailInput component
            var fieldConfigOverride = __assign(__assign({}, fieldConfig), { pattern: EMAIL_PATTERN.source });
            return checkFor(['pattern'], fieldConfigOverride, value);
        }
        return checkFor(['minLength', 'maxLength', 'pattern'], fieldConfig, value);
    }
    if (fieldConfig.fieldType === 'number') {
        return checkFor(['minLength', 'maxLength'], fieldConfig, value);
    }
    return false;
};
